/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import PropTypes from "prop-types";
import { map } from "lodash";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import toast, { Toaster } from "react-hot-toast";
import {
  InformacionInicialCatalogos,
  HandleCheck,
  HandleEdit,
  HandleEditText,
  HandleSaveCat,
  HandleEditSave,
} from "store/catalogos/catalogosActions";
import Loading from "../../components/loading";

import TableCatalogos from "layouts/profile/components/PlatformSettings";
import { store } from "store/store";
import _ from "lodash";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <MDBox sx={{ p: 3 }}>
          <MDTypography>{children}</MDTypography>
        </MDBox>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

import { useTheme } from "@mui/material/styles";

function Catalogos() {
  //const {permisos} = useSelector((state) => state.roles);
  const theme = useTheme();
  const {
    hospitales,
    parentescos,
    serMedicos,
    estudiosMedicos,
    correos,
    isloadingHospitales,
    isloadingParentescos,
    isloadingSerMedicos,
    isloadingestudiosMedicos,
    isloadingcorreos,
  } = useSelector((state) => state.catalogos);
  const [mTextHospital, setmTextHospital] = useState(false);
  const [mTextParentesco, setmTextParentesco] = useState(false);
  const [mTextSerMedico, setmTextSerMedico] = useState(false);
  const [mTextEstudio, setmTextEstudio] = useState(false);
  const [mTextCorreo, setmTextCorreo] = useState(false);

  const [valueTextHospital, setvTextHospital] = useState("");
  const [valueTextParentesco, setvTextParentesco] = useState("");
  const [valueTextSerMedico, setvTextSerMedico] = useState("");
  const [valueTextEstudio, setvTextEstudio] = useState("");
  const [valueTextCorreo, setvTextCorreo] = useState("");

  const dispatch = useDispatch();
  useEffect(() => {
    InformacionInicialCatalogos(dispatch);
  }, []);
  //Activar panel navegacion
  const [tabValue, setTabValue] = useState(0);
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const handleChangeIndex = (index) => setTabValue(index);

  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const verhospitales = _.filter(usuarioPermisos, (p) => p.idPermiso == 97);
  const verserviciosmedicos = _.filter(usuarioPermisos, (p) => p.idPermiso == 98);
  const verparentescos = _.filter(usuarioPermisos, (p) => p.idPermiso == 99);
  const verestudiosmedicos = _.filter(usuarioPermisos, (p) => p.idPermiso == 100);
  const verdestinatarios = _.filter(usuarioPermisos, (p) => p.idPermiso == 101);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={1}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3}>
                <AppBar position="static">
                  <Tabs orientation={"horizontal"} value={tabValue} onChange={handleSetTabValue}>
                    {verhospitales.length == 0 ? null : (
                      <Tab
                        label="Hospitales"
                        style={{ fontSize: 12 }}
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            night_shelter
                          </Icon>
                        }
                      />
                    )}
                    {verserviciosmedicos.length == 0 ? null : (
                      <Tab
                        label="Servicios medicos"
                        style={{ fontSize: 12 }}
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            medical_information
                          </Icon>
                        }
                      />
                    )}
                    {verparentescos.length == 0 ? null : (
                      <Tab
                        label="Parentesco"
                        style={{ fontSize: 12 }}
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            family_restroom
                          </Icon>
                        }
                      />
                    )}
                    {verestudiosmedicos.length == 0 ? null : (
                      <Tab
                        label="Estudios medicos"
                        style={{ fontSize: 12 }}
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            science
                          </Icon>
                        }
                      />
                    )}
                    {verdestinatarios.length == 0 ? null : (
                      <Tab
                        label="Correos de destinatarios"
                        style={{ fontSize: 12 }}
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            email
                          </Icon>
                        }
                      />
                    )}
                  </Tabs>
                </AppBar>
                {verhospitales.length == 0 &&
                verserviciosmedicos.length == 0 &&
                verparentescos.length == 0 &&
                verestudiosmedicos.length == 0 &&
                verdestinatarios.length == 0 ? (
                  <MDBox textAlign="center">
                    <MDTypography variant="h6" color="white">
                      No cuenta con permisos de visualización
                    </MDTypography>
                  </MDBox>
                ) : null}
                <SwipeableViews
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={tabValue}
                  onChangeIndex={handleChangeIndex}
                >
                  {verhospitales.length == 0 ? null : (
                    <TabPanel value={tabValue} index={0} dir={theme.direction}>
                      {isloadingHospitales ? (
                        <Loading title={"Procesando por favor espere!"} />
                      ) : (
                        <TableCatalogos
                          title="Hospitales"
                          data={map(hospitales, (item) => {
                            return {
                              text: item.hospital,
                              activo: item.activo,
                              ...item,
                            };
                          })}
                          onChange={(item) => {
                            HandleCheck(dispatch, { catalogo: "hospitales", item });
                          }}
                          openModalText={() => {
                            setmTextHospital(true);
                          }}
                          mostrarTextSave={mTextHospital}
                          valueNew={valueTextHospital}
                          onchangeNew={(value) => {
                            setvTextHospital(value);
                          }}
                          onchangeNewSave={() => {
                            //guardar nuevo registro
                            if (!valueTextHospital) {
                              toast.error("Ingresa el nombre el nuevo hospital");
                              return false;
                            }

                            HandleSaveCat(dispatch, {
                              catalogo: "hospitales",
                              value: valueTextHospital,
                            });
                            setvTextHospital("");
                            setmTextHospital(false);
                          }}
                          onCloseNew={() => {
                            setvTextHospital("");
                            setmTextHospital(false);
                          }}
                          onChangeEdit={(item) => {
                            HandleEdit(dispatch, { catalogo: "hospitales", item });
                          }}
                          onChangeSave={(item) => {
                            HandleEditSave(dispatch, { catalogo: "hospitales", item });
                          }}
                          onchangeText={(item, value) => {
                            HandleEditText(dispatch, { catalogo: "hospitales", item, value });
                          }}
                        />
                      )}
                    </TabPanel>
                  )}
                  {verserviciosmedicos.length == 0 ? null : (
                    <TabPanel value={tabValue} index={1} dir={theme.direction}>
                      {isloadingSerMedicos ? (
                        <Loading title={"Procesando por favor espere!"} />
                      ) : (
                        <TableCatalogos
                          title="Servicios medicos"
                          data={map(serMedicos, (item) => {
                            return {
                              text: item.descripcion,
                              activo: item.activo,
                              ...item,
                            };
                          })}
                          onChange={(item) => {
                            HandleCheck(dispatch, { catalogo: "servicios", item });
                          }}
                          openModalText={() => {
                            setmTextSerMedico(true);
                          }}
                          mostrarTextSave={mTextSerMedico}
                          valueNew={valueTextSerMedico}
                          onchangeNew={(value) => {
                            setvTextSerMedico(value);
                          }}
                          onchangeNewSave={() => {
                            //guardar nuevo registro
                            HandleSaveCat(dispatch, {
                              catalogo: "servicios",
                              value: valueTextSerMedico,
                            });
                            setmTextSerMedico(false);
                          }}
                          onCloseNew={() => {
                            setvTextSerMedico("");
                            setmTextSerMedico(false);
                          }}
                          onChangeEdit={(item) => {
                            HandleEdit(dispatch, { catalogo: "servicios", item });
                          }}
                          onChangeSave={(item) => {
                            HandleEditSave(dispatch, { catalogo: "servicios", item });
                          }}
                          onchangeText={(item, value) => {
                            HandleEditText(dispatch, { catalogo: "servicios", item, value });
                          }}
                        />
                      )}
                    </TabPanel>
                  )}
                  {verparentescos.length == 0 ? null : (
                    <TabPanel value={tabValue} index={2} dir={theme.direction}>
                      {isloadingParentescos ? (
                        <Loading title={"Procesando por favor espere!"} />
                      ) : (
                        <TableCatalogos
                          title="Parentescos"
                          data={map(parentescos, (item) => {
                            return {
                              text: item.descripcion,
                              activo: item.activo,
                              ...item,
                            };
                          })}
                          onChange={(item) => {
                            HandleCheck(dispatch, { catalogo: "parentescos", item });
                          }}
                          openModalText={() => {
                            setmTextParentesco(true);
                          }}
                          mostrarTextSave={mTextParentesco}
                          valueNew={valueTextParentesco}
                          onchangeNew={(value) => {
                            setvTextParentesco(value);
                          }}
                          onchangeNewSave={() => {
                            //guardar nuevo registro
                            HandleSaveCat(dispatch, {
                              catalogo: "parentescos",
                              value: valueTextParentesco,
                            });
                            setvTextParentesco("");
                            setmTextParentesco(false);
                          }}
                          onCloseNew={() => {
                            setvTextParentesco("");
                            setmTextParentesco(false);
                          }}
                          onChangeEdit={(item) => {
                            HandleEdit(dispatch, { catalogo: "parentescos", item });
                          }}
                          onChangeSave={(item) => {
                            HandleEditSave(dispatch, { catalogo: "parentescos", item });
                          }}
                          onchangeText={(item, value) => {
                            HandleEditText(dispatch, { catalogo: "parentescos", item, value });
                          }}
                        />
                      )}
                    </TabPanel>
                  )}
                  {verestudiosmedicos.length == 0 ? null : (
                    <TabPanel value={tabValue} index={3} dir={theme.direction}>
                      {isloadingestudiosMedicos ? (
                        <Loading title={"Procesando por favor espere!"} />
                      ) : (
                        <TableCatalogos
                          title="Estudios medicos"
                          data={map(estudiosMedicos, (item) => {
                            return {
                              text: item.descripcion,
                              activo: item.activo,
                              ...item,
                            };
                          })}
                          onChange={(item) => {
                            HandleCheck(dispatch, { catalogo: "estudios", item });
                          }}
                          openModalText={() => {
                            setmTextEstudio(true);
                          }}
                          mostrarTextSave={mTextEstudio}
                          valueNew={valueTextEstudio}
                          onchangeNew={(value) => {
                            setvTextEstudio(value);
                          }}
                          onchangeNewSave={() => {
                            //guardar nuevo registro
                            HandleSaveCat(dispatch, {
                              catalogo: "estudios",
                              value: valueTextEstudio,
                            });
                            setvTextEstudio("");
                            setmTextEstudio(false);
                          }}
                          onCloseNew={() => {
                            setvTextEstudio("");
                            setmTextEstudio(false);
                          }}
                          onChangeEdit={(item) => {
                            HandleEdit(dispatch, { catalogo: "estudios", item });
                          }}
                          onChangeSave={(item) => {
                            HandleEditSave(dispatch, { catalogo: "estudios", item });
                          }}
                          onchangeText={(item, value) => {
                            HandleEditText(dispatch, { catalogo: "estudios", item, value });
                          }}
                        />
                      )}
                    </TabPanel>
                  )}
                  {verdestinatarios.length == 0 ? null : (
                    <TabPanel value={tabValue} index={4} dir={theme.direction}>
                      {isloadingcorreos ? (
                        <Loading title={"Procesando por favor espere!"} />
                      ) : (
                        <TableCatalogos
                          title="Correos de destinatarios"
                          data={map(correos, (item) => {
                            return {
                              text: item.correo,
                              activo: item.activo,
                              ...item,
                            };
                          })}
                          onChange={(item) => {
                            HandleCheck(dispatch, { catalogo: "correos", item });
                          }}
                          openModalText={() => {
                            setmTextCorreo(true);
                          }}
                          mostrarTextSave={mTextCorreo}
                          valueNew={valueTextCorreo}
                          onchangeNew={(value) => {
                            setvTextCorreo(value);
                          }}
                          onchangeNewSave={() => {
                            //guardar nuevo registro
                            HandleSaveCat(dispatch, {
                              catalogo: "correos",
                              value: valueTextCorreo,
                            });
                            setvTextCorreo("");
                            setmTextCorreo(false);
                          }}
                          onCloseNew={() => {
                            setvTextCorreo("");
                            setmTextCorreo(false);
                          }}
                          onChangeEdit={(item) => {
                            HandleEdit(dispatch, { catalogo: "correos", item });
                          }}
                          onChangeSave={(item) => {
                            HandleEditSave(dispatch, { catalogo: "correos", item });
                          }}
                          onchangeText={(item, value) => {
                            HandleEditText(dispatch, { catalogo: "correos", item, value });
                          }}
                        />
                      )}
                    </TabPanel>
                  )}
                </SwipeableViews>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Toaster
        toastOptions={{ style: { backgroundColor: "#5873B8", fontSize: 12, color: "white" } }}
      />
    </DashboardLayout>
  );
}

export default Catalogos;
